<div class="fixed w-screen h-screen top-0 left-0 flex flex-col justify-center items-center bg-white bg-opacity-40 z-max" [ngClass]="{'rtl':(language | language )}" >
  <lottie-player   src="/assets/lottie/s-loader.json" background="transparent" speed="1"
  style="width: 17rem; height: 17rem;" loop autoplay="false"></lottie-player>
  </div>
